"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.installKeyboardHandler = exports.ensureGameHandlesKey = exports.addKey = exports.addHandler = exports.getKeys = void 0;
var imports_1 = require("@lib/imports");
var onceOnly_1 = require("@lib/onceOnly");
var common_sidecar_1 = require("@main/common-sidecar");
var textInputs_sidecar_1 = require("@uiParts/textInputs-sidecar");
var keys = {
    godMode: false,
    shift: false,
    control: false,
    alt: false,
    cameraUp: false,
    cameraDown: false,
    cameraLeft: false,
    cameraRight: false,
};
var getKeys = function () {
    return keys;
};
exports.getKeys = getKeys;
var _handlers = [];
var addHandler = function (codes, on, off, change) {
    if (on === void 0) { on = function () { }; }
    if (off === void 0) { off = function () { }; }
    if (change === void 0) { change = function () { }; }
    if (!imports_1.l.isArray(codes)) {
        codes = [codes];
    }
    imports_1.l.forEach(codes, function (c) {
        exports.ensureGameHandlesKey(c);
        _handlers.push({ code: c, on: on, off: off, change: change });
    });
};
exports.addHandler = addHandler;
var addKey = function (codes, property) {
    exports.addHandler(codes, function () { }, function () { }, function (isDown) {
        // console.log('key property changed', codes, property, isDown)
        keys[property] = isDown;
    });
};
exports.addKey = addKey;
var ensureGameHandlesKey = function (key) {
    var s = common_sidecar_1.common.getPhaserScene();
    s.input.keyboard.addKey(key);
};
exports.ensureGameHandlesKey = ensureGameHandlesKey;
var installKeyboardHandler = function (namespace) {
    onceOnly_1.ensureCalledOnlyOnce('installKeyboardHandler');
    var s = common_sidecar_1.common.getPhaserScene();
    console.log(namespace, 'add keyboard handler');
    s.input.keyboard.on('keydown', function (event) {
        console.log(namespace, 'key down', 'key', event.key, 'keyCode', event.keyCode, 'code', event.code);
        // if (underMenuController.handleKeydown(event.code)) {
        //   return
        // }
        if (textInputs_sidecar_1.textInputs.hasFocus()) {
            textInputs_sidecar_1.textInputs.handleKeyboardInput(event.key, event.keyCode, event.code);
        }
        else {
            _handlers.forEach(function (c) {
                if (c.code === event.code) {
                    console.log(namespace, 'hit handler');
                    if (c.on) {
                        c.on();
                    }
                    if (c.change) {
                        c.change(true);
                    }
                }
            });
        }
    });
    s.input.keyboard.on('keyup', function (event) {
        imports_1.l.forEach(textInputs_sidecar_1.textInputs.textInputAlphabet, function (c) {
            s.input.keyboard.addKey(c);
        });
        if (textInputs_sidecar_1.textInputs.hasFocus()) {
            textInputs_sidecar_1.textInputs.handleKeyboardInput(event.key, event.keyCode, event.code);
        }
        else {
            imports_1.l.forEach(_handlers, function (c) {
                if (c.code === event.code) {
                    if (c.off) {
                        c.off();
                    }
                    if (c.change) {
                        c.change(false);
                    }
                }
            });
        }
    });
};
exports.installKeyboardHandler = installKeyboardHandler;
